import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastProps, toastStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-toast',
  template: `
    <div [ngClass]="toast" class="kite-toast" role="alert">
      <div class="toast-wrapper">
        <kite-icon [name]="getStatusIcon()" aria-label="" size="md"></kite-icon>
        <div class="toast-content">
          <div>
            <h2>{{ title }}</h2>
            <p kiteText *ngIf="description" size="sm">{{ description }}</p>
          </div>
          <div #linkRef>
            <ng-content></ng-content>
          </div>
        </div>
      </div>
      <kite-close-action [onDark]="true" [css]="{ m: -2 }" (onClick)="onClick.emit($event)"></kite-close-action>
    </div>
  `,
})
export class ToastComponent implements AfterViewInit {
  /**
   * Variante del toast (informative, warning o success)
   */
  @Input() variant: ToastProps['variant'];

  /**
   * Título del toast
   */
  @Input() title: ToastProps['title'];

  /**
   * Descripción del toast
   */
  @Input() description: ToastProps['description'];

  /**
   * Estado del toast
   */
  @Input() isOpen = false;

  /**
   * CSS del toastlist
   */
  @Input() css: ToastProps['css'];

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  isFixed = false;

  @ViewChild('linkRef') linkRef: ElementRef;

  public get toast(): string[] {
    return [
      toastStyles({
        variant: this.variant,
        isOpen: this.isOpen,
        isFixed: this.isFixed,
        css: this.css,
      }).className,
    ];
  }

  getStatusIcon = () => {
    if (this.variant === 'success') {
      return 'check';
    } else if (this.variant === 'warning') {
      return 'warning';
    } else {
      return 'info';
    }
  };

  ngAfterViewInit() {
    if (this.linkRef) {
      if (this.linkRef.nativeElement.childNodes.length > 0 && !this.description) {
        this.isFixed = true;
      } else if (this.linkRef.nativeElement.childNodes.length === 0) {
        this.linkRef.nativeElement.remove();
      }
    }
  }
}
